import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgCheckIn = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 17,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 10a1 1 0 0 1 1 1v1a2 2 0 0 1 2 2v3a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-3a2 2 0 0 1 2-2v-1a1 1 0 0 1 1-1h3ZM5 6a1 1 0 0 1 1 1v5H5v6H1v-6H0V7a1 1 0 0 1 1-1h4Zm9 7H9a1 1 0 0 0-.993.883L8 14v3h7v-3a1 1 0 0 0-.883-.993L14 13ZM5 7H1v4h1v6h2v-6h1V7Zm5 7v2H9v-2h1Zm3-3h-3v1h3v-1ZM16.146.146l.708.708L10.5 7.207 7.646 4.354l.708-.708L10.5 5.793 16.146.146ZM3 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgCheckIn;